/** Import modules */

import { useTranslation }   from "react-i18next";

import { Helmet }           from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                           from "../../Components/SEO/localizedMeta";

/** Import components */

import Breadcrumbs          from "../../Components/Layout/Header/Breadcrumbs";

import ContactsSection      from "../../Components/Contacts/Section";

/** Import datasets */

import { ContactsDataset }      from "../../Datasets/Contacts";

/** Import assets */

import "../../Styles/Contacts.css";

const Contacts = () => { const { t, i18n } = useTranslation ();

    const currentLanguage = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language);

    const canonicalHref = localizedAbsoluteUrl("/content/contacts", currentLanguage);

    const alternateLinks = hreflangLinks("/content/contacts");

    const pageDescription = localizedValue({
        lv: "Tireshop.lv kontakti: tālruņi, e-pasti, darba laiks un servisa atrašanās vieta. Sazinies par riepu, disku, akumulatoru iegādi un autoservisa pakalpojumiem.",
        en: "Tireshop.lv contacts: phone numbers, e-mails, opening hours, and service location. Get in touch about tires, rims, batteries, and car service.",
        ru: "Контакты Tireshop.lv: телефоны, e-mail, время работы и адрес сервиса. Свяжитесь с нами по поводу шин, дисков, аккумуляторов и автосервиса."
    }, currentLanguage);

    /** Render component */

    return ( <div className="container max-content-width">

        <Helmet>

            <title>{ `Tireshop.lv | ${ t ( "contacts" ) }` }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "contacts" ), URI: "/content/contacts" }

        ] } />
    
        <div className="content contacts">

            { ContactsDataset ().Sections.map ( ( section, index ) => <ContactsSection 
            
                title={ section.title } 
            
                key={ index }>

                    { section.content }

            </ContactsSection> ) }

        </div>
        
    </div> );

}

/** Export component */
 
export default Contacts;
